import React, { useState } from 'react';

export default function FilterBar({ filters, availablePlays, onFilterChange }) {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleFilterUpdate = (key, value) => {
    const newFilters = { ...localFilters, [key]: value };
    setLocalFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleReset = () => {
    const defaultFilters = {
      playId: null,
      dateFrom: null,
      dateTo: null,
      cohort: 'all',
      sortBy: 'improvement',
      sortOrder: 'desc'
    };
    setLocalFilters(defaultFilters);
    onFilterChange(defaultFilters);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-gray-900">Filters</h3>
        <button
          onClick={handleReset}
          className="text-sm text-indigo-600 hover:text-indigo-700 font-medium"
        >
          Reset Filters
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Play Filter */}
        <div>
          <label htmlFor="play-filter" className="block text-sm font-medium text-gray-700 mb-1">
            Shakespeare Play
          </label>
          <select
            id="play-filter"
            value={localFilters?.playId || ''}
            onChange={(e) => handleFilterUpdate('playId', e?.target?.value || null)}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          >
            <option value="">All Plays</option>
            {availablePlays?.map(play => (
              <option key={play?.id} value={play?.id}>
                {play?.title}
              </option>
            ))}
          </select>
        </div>

        {/* Date From Filter */}
        <div>
          <label htmlFor="date-from" className="block text-sm font-medium text-gray-700 mb-1">
            From Date
          </label>
          <input
            type="date"
            id="date-from"
            value={localFilters?.dateFrom || ''}
            onChange={(e) => handleFilterUpdate('dateFrom', e?.target?.value || null)}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          />
        </div>

        {/* Date To Filter */}
        <div>
          <label htmlFor="date-to" className="block text-sm font-medium text-gray-700 mb-1">
            To Date
          </label>
          <input
            type="date"
            id="date-to"
            value={localFilters?.dateTo || ''}
            onChange={(e) => handleFilterUpdate('dateTo', e?.target?.value || null)}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          />
        </div>

        {/* Cohort Filter */}
        <div>
          <label htmlFor="cohort-filter" className="block text-sm font-medium text-gray-700 mb-1">
            Student Cohort
          </label>
          <select
            id="cohort-filter"
            value={localFilters?.cohort}
            onChange={(e) => handleFilterUpdate('cohort', e?.target?.value)}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          >
            <option value="all">All Students</option>
            <option value="beginner">Beginner Level</option>
            <option value="intermediate">Intermediate Level</option>
            <option value="advanced">Advanced Level</option>
          </select>
        </div>
      </div>
      {/* Active Filters Display */}
      {(localFilters?.playId || localFilters?.dateFrom || localFilters?.dateTo || localFilters?.cohort !== 'all') && (
        <div className="mt-4 flex flex-wrap gap-2">
          {localFilters?.playId && (
            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
              Play: {availablePlays?.find(p => p?.id === localFilters?.playId)?.title}
              <button
                onClick={() => handleFilterUpdate('playId', null)}
                className="ml-2 text-indigo-600 hover:text-indigo-900"
              >
                ×
              </button>
            </span>
          )}
          {localFilters?.dateFrom && (
            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
              From: {new Date(localFilters.dateFrom)?.toLocaleDateString()}
              <button
                onClick={() => handleFilterUpdate('dateFrom', null)}
                className="ml-2 text-indigo-600 hover:text-indigo-900"
              >
                ×
              </button>
            </span>
          )}
          {localFilters?.dateTo && (
            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
              To: {new Date(localFilters.dateTo)?.toLocaleDateString()}
              <button
                onClick={() => handleFilterUpdate('dateTo', null)}
                className="ml-2 text-indigo-600 hover:text-indigo-900"
              >
                ×
              </button>
            </span>
          )}
          {localFilters?.cohort !== 'all' && (
            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
              Cohort: {localFilters?.cohort}
              <button
                onClick={() => handleFilterUpdate('cohort', 'all')}
                className="ml-2 text-indigo-600 hover:text-indigo-900"
              >
                ×
              </button>
            </span>
          )}
        </div>
      )}
    </div>
  );
}